import Request from '@request/Request';
import Model from '@models/Project';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      project: {
        id: '',
        name: '',
        media: [],
      },
      project_id: '',
      amount: '',
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    try {
      let url = '/';
      return await new Model().payout(this.data());
    } catch (error) {
      this.handleError(error, 'project-payout');
    } finally {
      this.afterSubmit();
    }
  }
}
